// extracted by mini-css-extract-plugin
export default {"footerMenuItem":"SidebarFooterMenu_footerMenuItem__1uMSS","versionNumber":"SidebarFooterMenu_versionNumber__JC6z6"};